import React, { FC, ReactNode } from 'react';
import { Box, Card } from '@edreamsodigeo/prisma-design-system';
import ItineraryCard from '@components/Results/Components/Itinerary/ItineraryCard';
import ItineraryDeal from '../../Deals/ItineraryDeal';
import { useItinerary } from '@components/Results/Components/Itinerary/Provider';
import {
  DEAL_WEEKEND,
  DEAL_HOTTEST,
} from 'clientState/hooks/useGetBuyPathDeal';
import { useFlowTools } from 'flowTools/useFlowTools';
import ItineraryHeaderRevamp from '@components/Results/Components/ThreeColumnsItinerary/ItineraryHeader/ItineraryHeaderRevamp';
import { ItineraryDecorationProps } from '../types';

type ItineraryProps = {
  isAlternativeItinerary?: boolean;
  hasAlternativeItineraryDecorator?: boolean;
  isUnavailable?: boolean;
  children: ReactNode;
};

const ItineraryWrapper: FC<ItineraryProps> = ({ children }) => {
  const { highlightedType } = useItinerary();
  const Wrapper =
    highlightedType === DEAL_WEEKEND || highlightedType === DEAL_HOTTEST
      ? ItineraryDeal
      : Box;
  return <Wrapper data-testid="itinerary">{children}</Wrapper>;
};

const ItineraryDecorationDefault: FC<ItineraryProps> = ({
  isAlternativeItinerary,
  hasAlternativeItineraryDecorator,
  isUnavailable,
  children,
}) => {
  const { isDesktop } = useFlowTools();
  const pad = isDesktop ? 0 : 4;
  const sx =
    (isAlternativeItinerary && !hasAlternativeItineraryDecorator) ||
    isUnavailable
      ? {
          backgroundColor: 'neutral.20',
          border: '1px solid',
          borderColor: 'neutral.60',
        }
      : {};
  return (
    <Box data-testid="itinerary">
      <Card p={pad} sx={sx}>
        {children}
      </Card>
    </Box>
  );
};

const ItineraryDecorationHighlighted: FC<ItineraryDecorationProps> = ({
  children,
  highlightedType,
  ...props
}) => {
  return (
    <ItineraryWrapper>
      <ItineraryHeaderRevamp highlightedType={highlightedType} />
      <ItineraryCard highlightedType={highlightedType} {...props}>
        {children}
      </ItineraryCard>
    </ItineraryWrapper>
  );
};

const ItineraryDecorationRevamp: FC<ItineraryDecorationProps> = ({
  children,
  highlightedType,
  hasRetailingTechniques = true,
  isAlternativeItinerary = false,
  hasAlternativeItineraryDecorator = false,
  ...props
}) => {
  return highlightedType !== 'default' &&
    hasRetailingTechniques &&
    !isAlternativeItinerary ? (
    <ItineraryDecorationHighlighted
      highlightedType={highlightedType}
      {...props}
    >
      {children}
    </ItineraryDecorationHighlighted>
  ) : (
    <ItineraryDecorationDefault
      isAlternativeItinerary={isAlternativeItinerary}
      hasAlternativeItineraryDecorator={hasAlternativeItineraryDecorator}
    >
      {children}
    </ItineraryDecorationDefault>
  );
};

export default ItineraryDecorationRevamp;
